import { useLocaleState, useRecordContext } from "ra-core";
import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { ReferenceField } from "@/components/admin/reference-field";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";

import { StatusBadge } from "../faromarket-shared/StatusBadge";
import { formatRelativeDate } from "../misc/RelativeDate";

const TYPE_CHOICES = [
  { id: "form_submission", name: "form_submission" },
  { id: "note", name: "note" },
  { id: "whatsapp", name: "whatsapp" },
  { id: "email", name: "email" },
  { id: "phone_call", name: "phone_call" },
  { id: "meeting", name: "meeting" },
  { id: "system_event", name: "system_event" },
  { id: "status_change", name: "status_change" },
  { id: "task_update", name: "task_update" },
  { id: "proposal", name: "proposal" },
];

const DIRECTION_CHOICES = [
  { id: "inbound", name: "crm.faromarket.direction.inbound" },
  { id: "outbound", name: "crm.faromarket.direction.outbound" },
  { id: "internal", name: "crm.faromarket.direction.internal" },
  { id: "system", name: "crm.faromarket.direction.system" },
];

const InteractionFilters = [
  <SearchInput source="title@ilike" alwaysOn />,
  <SelectInput source="type" choices={TYPE_CHOICES} />,
  <SelectInput
    source="direction"
    choices={DIRECTION_CHOICES}
    translateChoice
  />,
];

const DirectionField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.direction} kind="direction" />;
};

const RelativeDateField = ({ source }: { source: string }) => {
  const record = useRecordContext();
  const [locale = "pt-BR"] = useLocaleState();
  const value = record?.[source];
  if (!value) return <span className="text-muted-foreground">—</span>;
  return <span>{formatRelativeDate(value, locale)}</span>;
};

export const InteractionList = () => (
  <List
    perPage={25}
    sort={{ field: "occurred_at", order: "DESC" }}
    filter={{ is_test: false }}
    filters={InteractionFilters}
  >
    <DataTable>
      <DataTable.Col source="type" label="resources.interactions.fields.type" />
      <DataTable.Col
        source="channel"
        label="resources.interactions.fields.channel"
      />
      <DataTable.Col
        source="direction"
        label="resources.interactions.fields.direction"
      >
        <DirectionField />
      </DataTable.Col>
      <DataTable.Col
        source="title"
        label="resources.interactions.fields.title"
      />
      <DataTable.Col
        source="company_id"
        label="resources.interactions.fields.company_id"
      >
        <ReferenceField
          source="company_id"
          reference="companies"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col
        source="contact_id"
        label="resources.interactions.fields.contact_id"
      >
        <ReferenceField
          source="contact_id"
          reference="contacts"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col
        source="lead_id"
        label="resources.interactions.fields.lead_id"
      >
        <ReferenceField
          source="lead_id"
          reference="leads"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col
        source="deal_id"
        label="resources.interactions.fields.deal_id"
      >
        <ReferenceField
          source="deal_id"
          reference="deals"
          link={false}
          empty="—"
        />
      </DataTable.Col>
      <DataTable.Col
        source="occurred_at"
        label="resources.interactions.fields.occurred_at"
      >
        <RelativeDateField source="occurred_at" />
      </DataTable.Col>
    </DataTable>
  </List>
);
